import React from 'react';
import { Box, Button, Fade, useTheme } from '@mui/material';

interface VideoPreviewModalProps {
    videoUrl: string;
    open: boolean;
    onClose: () => void;
}

const VideoPreviewModal: React.FC<VideoPreviewModalProps> = ({ videoUrl, open, onClose }) => {
    const theme = useTheme();

    if (!open) return null;

    return (
        <Fade in={open}>
            <Box
                sx={{
                    position: 'fixed',
                    inset: 0,
                    bgcolor: 'rgba(0,0,0,0.8)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 1400,
                }}
                onClick={onClose}
            >
                <Box
                    sx={{
                        position: 'relative',
                        maxWidth: '90%',
                        maxHeight: '90%',
                        bgcolor: 'transparent',
                        borderRadius: 0,
                        p: 0,
                        boxShadow: 'none',
                    }}
                    onClick={(e) => e.stopPropagation()}
                >
                    <Box
                        component="video"
                        src={videoUrl}
                        controls
                        autoPlay
                        style={{
                            display: 'block',
                            maxWidth: '100%',
                            maxHeight: '80vh',
                            objectFit: 'contain',
                            borderRadius: 0,
                            backgroundColor: 'black', // принудительно чёрный фон
                        }}
                    />

                    <Button
                        onClick={onClose}
                        variant="contained"
                        sx={{
                            mt: 2,
                            display: 'block',
                            ml: 'auto',
                            backgroundColor: theme.palette.primary.main,
                            color: theme.palette.primary.contrastText,
                            '&:hover': {
                                backgroundColor: theme.palette.primary.dark,
                            },
                        }}
                    >
                        Close
                    </Button>
                </Box>
            </Box>
        </Fade>
    );
};

export default VideoPreviewModal;